export const SPINNER_BADGE_DEFAULT_ICON_LOADING_TITLE = 'start-icon-loading';
//# sourceMappingURL=SpinnerBadge.constants.js.map